import { diff } from 'deep-object-diff'

export function areEqualObjects(obj1, obj2) {
	if (obj1 !== undefined && obj2 !== undefined) {
		return Object.keys(diff(obj1, obj2)).length === 0 ? true : false
	}
	return false
}
